var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcEdit = function SvgIcEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.659 4.514c.374-.375 1.039-.375 1.414 0l1.414 1.414c.187.188.29.439.29.707 0 .269-.103.52-.29.707l-.707.707-2.83-2.828.709-.707ZM5.179 17.077l.873.872.872.872-2.326.582.582-2.326Zm9.358-10.442 1.414 1.414 1.415 1.414-8.486 8.486-1.414-1.414-1.414-1.415 8.485-8.485ZM3.223 21.778c.082 0 .163-.01.243-.031l5.657-1.415c.03-.007.056-.023.084-.033a.972.972 0 0 0 .377-.227l.003-.002 9.9-9.9L20.9 8.756a2.976 2.976 0 0 0 .876-2.121c0-.803-.311-1.557-.876-2.121L19.487 3.1c-1.131-1.131-3.113-1.131-4.243 0L13.83 4.514l-9.9 9.899-.002.004a1.004 1.004 0 0 0-.224.368c-.011.032-.028.06-.037.093l-1.414 5.657a1.002 1.002 0 0 0 .97 1.243ZM8.88 15.12a.997.997 0 0 0 1.414 0l4.243-4.243a1 1 0 0 0-1.414-1.414L8.88 13.706a.999.999 0 0 0 0 1.414",
    id: "ic_edit_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic_edit_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic_edit_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic_edit_svg__b)",
    fill: "#6B6C72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcEdit;